import template from './fullCalendar.html';
import controller from './fullCalendar.controller';
import './fullCalendar.scss';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isOnline: '<',
    staffUser: '<'
  }
};

export default component;
